export default{
     async registerRequest(context,payload){
         let requestData = {
             email: payload.email,
        
             message: payload.message,
             id: new Date().toISOString()
         }
         const response = await fetch(`https://coach-finder-vue-dd363-default-rtdb.firebaseio.com/requests/${payload.coachId}.json`,{
             body: JSON.stringify(requestData),
             method:'POST'
         })
         let responseData = response.json();
         if(!response.ok){
             let error = new Error(responseData.message || 'Failed to add new requests')
             throw error
         }
         context.commit('addRequest',requestData)
     },
     async loadRequests(context){
     
        let coachId = context.rootGetters.userId;
        const token = context.rootGetters.token;
        const response = await fetch(`https://coach-finder-vue-dd363-default-rtdb.firebaseio.com/requests/${coachId}.json?auth=${token}`);
        let responseData = await response.json();
        if(!response.ok){
            let error = new Error(responseData.message || 'Failed to fetch requests')
            throw error
        }
        let requests = []
        for( const key in responseData){
            const{email,message} = responseData[key];
            let requestData = {
                email,message,id: key,coachId
            }
            requests.push(requestData)
        }
        context.commit('setRequests',requests)

     }
}